export default (value: number | string) =>
  isNaN(Number(value))
    ? ''
    : Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(
        Number(value),
      );
